module.exports = __webpack_public_path__ + "static/media/descanso-correcto.153a957c.jpg";